import { when, set } from 'cerebral/operators'
import { state } from 'cerebral/tags'
import onCloseDetailedView from './onCloseDetailedView'

export default [
  when(state`media.showDetail`),
  {
    true: [...onCloseDetailedView],
    false: []
  },
  when(state`app.dialog`),
  {
    true: [set(state`app.dialog`, null)],
    false: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/onEscapeDown.js